import { useState } from "react";
import { useDebounce } from "shared/hooks/useDebounce.hook";
import { useResize } from "shared/hooks/useResize.hook";
import { AppDOM } from "shared/utils/app.utils";

type WindowSize = {
  width: undefined | number;
  height: undefined | number;
};

type UseWindowSizeParams = {
  debounceTime?: number;
};

export const useWindowSize = ({ debounceTime }: Partial<UseWindowSizeParams>): WindowSize => {
  const { debounce } = useDebounce(debounceTime);

  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: AppDOM.appContainer.clientWidth,
    height: AppDOM.appContainer.clientHeight,
  });

  const persistWindowSize = () => {
    setWindowSize({
      width: AppDOM.appContainer.clientWidth,
      height: AppDOM.appContainer.clientHeight,
    });
  };

  useResize(() => {
    if (typeof debounceTime !== "undefined") {
      debounce(() => {
        persistWindowSize();
      });
      return;
    }
    persistWindowSize();
  });

  return windowSize;
};
